import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  alertWrapper: theme => css`
    padding: 0 ${theme.spacing.sm};
    margin: 0 auto ${theme.spacing.xs};

    @media (min-width: ${theme.grid.breakpoint.sm}) {
      max-width: calc(100% - 2rem);
    }

    @media (min-width: ${theme.grid.breakpoint.lg}) {
      max-width: 976px;
    }

    @media (min-width: ${theme.grid.breakpoint.xl}) {
      max-width: 1040px;
    }
  `,
})

export { useStyles }
